import React from 'react';
import CustomerReminder from './containers/CustomerReminder';
import HoursMinsSelect from './components/HoursMinsSelect';
import Row from './components/Row';
import Common from './Common';

class BarberNotificationMethods extends Common {
  renderArrived() { // eslint-disable-line
    return <Row className="u-mb-" disabled={this.props.disabled} label="Arrived" action="notifications.arrived" />;
  }

  renderReminders() { // eslint-disable-line
    const commonHiddenFields = ['phone'];

    return (
      <div>
        <div className="u-mb-">
          <Row
            action="notifications.reminder"
            disabled={this.props.disabled}
            label="Barber Reminder"
            hide={this.props.edit ? [] : commonHiddenFields}
          />
          <HoursMinsSelect
            name="notifications.reminder.time"
            minInterval={this.props.minInterval}
            data-automation-id="barber-reminder-time"
          />
        </div>
        <div className="u-mb-">
          <CustomerReminder
            name="customerReminder"
            formSectionName={this.props.formSectionName}
            minInterval={this.props.minInterval}
          />
        </div>
      </div>
    );
  }

  render() {
    const { disabled } = this.props;
    const commonHiddenFields = ['phone'];

    return (
      <div className="layout__item">
        <div className="layout">
          <div className="layout__item u-1/2">
            <div className="c-heading c-heading--lightgrey u-pb u--ml">Preferred notification methods</div>
          </div>
        </div>

        <div className="layout">
          <div className="layout__item u-1/2">
            <Row
              disabled={disabled}
              className="u-mb-"
              label="Confirm"
              action="notifications.confirm"
              hide={this.props.edit ? [] : commonHiddenFields}
            />
            <Row disabled={disabled} className="u-mb-" label="Reschedule" action="notifications.reschedule" />
            <Row disabled={disabled} className="u-mb-" label="Cancel" action="notifications.cancel" />
            {this.renderArrived()}
          </div>
          <div className="layout__item u-1/2">{this.renderReminders()}</div>
        </div>
      </div>
    );
  }
}

export default BarberNotificationMethods;
